export const matrixScores = {
  sustainabilityPressure: {
    "automotive:OEM": 85, "automotive:T1": 70, "automotive:T2": 55, "automotive:T3": 40,
    "aerospace:OEM": 90, "aerospace:T1": 75, "aerospace:T2": 60, "aerospace:T3": 45,
    "electronics:OEM": 75, "electronics:T1": 60, "electronics:T2": 45, "electronics:T3": 30,
    "machinery:OEM": 70, "machinery:T1": 60, "machinery:T2": 50, "machinery:T3": 35
  },
  esgCompliance: {
    "automotive:OEM": 88, "automotive:T1": 72, "automotive:T2": 58, "automotive:T3": 40,
    "aerospace:OEM": 92, "aerospace:T1": 78, "aerospace:T2": 63, "aerospace:T3": 48,
    "electronics:OEM": 80, "electronics:T1": 65, "electronics:T2": 50, "electronics:T3": 35,
    "machinery:OEM": 75, "machinery:T1": 60, "machinery:T2": 48, "machinery:T3": 32
  },
  greenProductInnovation: {
    "automotive:OEM": 82, "automotive:T1": 68, "automotive:T2": 52, "automotive:T3": 38,
    "aerospace:OEM": 90, "aerospace:T1": 74, "aerospace:T2": 59, "aerospace:T3": 42,
    "electronics:OEM": 78, "electronics:T1": 62, "electronics:T2": 46, "electronics:T3": 30,
    "machinery:OEM": 72, "machinery:T1": 58, "machinery:T2": 45, "machinery:T3": 28
  },
  supplyChainCircularity: {
    "automotive:OEM": 80, "automotive:T1": 65, "automotive:T2": 50, "automotive:T3": 35,
    "aerospace:OEM": 85, "aerospace:T1": 70, "aerospace:T2": 55, "aerospace:T3": 40,
    "electronics:OEM": 75, "electronics:T1": 60, "electronics:T2": 45, "electronics:T3": 30,
    "machinery:OEM": 70, "machinery:T1": 55, "machinery:T2": 40, "machinery:T3": 25
  },
  supplierDependency: {
    "automotive:OEM": 70, "automotive:T1": 85, "automotive:T2": 78, "automotive:T3": 65,
    "aerospace:OEM": 72, "aerospace:T1": 86, "aerospace:T2": 80, "aerospace:T3": 68,
    "electronics:OEM": 65, "electronics:T1": 78, "electronics:T2": 70, "electronics:T3": 60,
    "machinery:OEM": 68, "machinery:T1": 75, "machinery:T2": 68, "machinery:T3": 55
  },
  collaborationNeed: {
    "automotive:OEM": 90, "automotive:T1": 85, "automotive:T2": 75, "automotive:T3": 60,
    "aerospace:OEM": 95, "aerospace:T1": 88, "aerospace:T2": 78, "aerospace:T3": 65,
    "electronics:OEM": 82, "electronics:T1": 75, "electronics:T2": 65, "electronics:T3": 50,
    "machinery:OEM": 80, "machinery:T1": 70, "machinery:T2": 60, "machinery:T3": 45
  },
  geographicSpread: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 65, "automotive:T3": 50,
    "aerospace:OEM": 90, "aerospace:T1": 83, "aerospace:T2": 70, "aerospace:T3": 55,
    "electronics:OEM": 75, "electronics:T1": 68, "electronics:T2": 55, "electronics:T3": 40,
    "machinery:OEM": 78, "machinery:T1": 70, "machinery:T2": 60, "machinery:T3": 45
  },
  supplierToolsGap: {
    "automotive:OEM": 65, "automotive:T1": 72, "automotive:T2": 80, "automotive:T3": 85,
    "aerospace:OEM": 70, "aerospace:T1": 78, "aerospace:T2": 82, "aerospace:T3": 87,
    "electronics:OEM": 60, "electronics:T1": 70, "electronics:T2": 75, "electronics:T3": 80,
    "machinery:OEM": 62, "machinery:T1": 68, "machinery:T2": 73, "machinery:T3": 78
  },
  supplierSLAPressure: {
    "automotive:OEM": 75, "automotive:T1": 82, "automotive:T2": 78, "automotive:T3": 70,
    "aerospace:OEM": 80, "aerospace:T1": 85, "aerospace:T2": 80, "aerospace:T3": 72,
    "electronics:OEM": 72, "electronics:T1": 78, "electronics:T2": 73, "electronics:T3": 65,
    "machinery:OEM": 70, "machinery:T1": 75, "machinery:T2": 70, "machinery:T3": 60
  },
  partnerEcosystemMaturity: {
    "automotive:OEM": 80, "automotive:T1": 75, "automotive:T2": 65, "automotive:T3": 50,
    "aerospace:OEM": 85, "aerospace:T1": 78, "aerospace:T2": 70, "aerospace:T3": 55,
    "electronics:OEM": 70, "electronics:T1": 65, "electronics:T2": 55, "electronics:T3": 45,
    "machinery:OEM": 68, "machinery:T1": 62, "machinery:T2": 52, "machinery:T3": 40
  },
  serviceRevenue: {
    "automotive:OEM": 78, "automotive:T1": 70, "automotive:T2": 60, "automotive:T3": 50,
    "aerospace:OEM": 85, "aerospace:T1": 77, "aerospace:T2": 65, "aerospace:T3": 55,
    "electronics:OEM": 72, "electronics:T1": 64, "electronics:T2": 55, "electronics:T3": 45,
    "machinery:OEM": 75, "machinery:T1": 68, "machinery:T2": 58, "machinery:T3": 48
  },
  businessModelShift: {
    "automotive:OEM": 85, "automotive:T1": 72, "automotive:T2": 60, "automotive:T3": 48,
    "aerospace:OEM": 90, "aerospace:T1": 78, "aerospace:T2": 65, "aerospace:T3": 52,
    "electronics:OEM": 80, "electronics:T1": 68, "electronics:T2": 55, "electronics:T3": 42,
    "machinery:OEM": 82, "machinery:T1": 70, "machinery:T2": 58, "machinery:T3": 46
  },
  lifecycleMonetization: {
    "automotive:OEM": 83, "automotive:T1": 70, "automotive:T2": 58, "automotive:T3": 46,
    "aerospace:OEM": 88, "aerospace:T1": 75, "aerospace:T2": 62, "aerospace:T3": 50,
    "electronics:OEM": 76, "electronics:T1": 64, "electronics:T2": 52, "electronics:T3": 40,
    "machinery:OEM": 78, "machinery:T1": 66, "machinery:T2": 54, "machinery:T3": 42
  },
  digitalThreadMonetization: {
    "automotive:OEM": 90, "automotive:T1": 75, "automotive:T2": 60, "automotive:T3": 45,
    "aerospace:OEM": 95, "aerospace:T1": 80, "aerospace:T2": 65, "aerospace:T3": 50,
    "electronics:OEM": 85, "electronics:T1": 70, "electronics:T2": 55, "electronics:T3": 40,
    "machinery:OEM": 88, "machinery:T1": 72, "machinery:T2": 58, "machinery:T3": 44
  },
  ipPortfolioLeverage: {
    "automotive:OEM": 80, "automotive:T1": 65, "automotive:T2": 50, "automotive:T3": 35,
    "aerospace:OEM": 85, "aerospace:T1": 68, "aerospace:T2": 52, "aerospace:T3": 38,
    "electronics:OEM": 78, "electronics:T1": 62, "electronics:T2": 48, "electronics:T3": 32,
    "machinery:OEM": 75, "machinery:T1": 60, "machinery:T2": 46, "machinery:T3": 30
  },
  programMarginUplift: {
    "automotive:OEM": 92, "automotive:T1": 80, "automotive:T2": 65, "automotive:T3": 50,
    "aerospace:OEM": 95, "aerospace:T1": 83, "aerospace:T2": 70, "aerospace:T3": 55,
    "electronics:OEM": 88, "electronics:T1": 74, "electronics:T2": 60, "electronics:T3": 46,
    "machinery:OEM": 86, "machinery:T1": 72, "machinery:T2": 58, "machinery:T3": 44
  },
  ipCapitalizationReadiness: {
    "automotive:OEM": 82, "automotive:T1": 68, "automotive:T2": 54, "automotive:T3": 40,
    "aerospace:OEM": 88, "aerospace:T1": 72, "aerospace:T2": 58, "aerospace:T3": 44,
    "electronics:OEM": 78, "electronics:T1": 64, "electronics:T2": 50, "electronics:T3": 36,
    "machinery:OEM": 80, "machinery:T1": 66, "machinery:T2": 52, "machinery:T3": 38
  },
  mAndAFrequency: {
    "automotive:OEM": 75, "automotive:T1": 68, "automotive:T2": 52, "automotive:T3": 40,
    "aerospace:OEM": 78, "aerospace:T1": 70, "aerospace:T2": 56, "aerospace:T3": 42,
    "electronics:OEM": 72, "electronics:T1": 66, "electronics:T2": 50, "electronics:T3": 38,
    "machinery:OEM": 70, "machinery:T1": 64, "machinery:T2": 48, "machinery:T3": 36
  },
  localizationDemand: {
    "automotive:OEM": 85, "automotive:T1": 75, "automotive:T2": 60, "automotive:T3": 45,
    "aerospace:OEM": 88, "aerospace:T1": 78, "aerospace:T2": 63, "aerospace:T3": 48,
    "electronics:OEM": 80, "electronics:T1": 70, "electronics:T2": 55, "electronics:T3": 42,
    "machinery:OEM": 82, "machinery:T1": 72, "machinery:T2": 58, "machinery:T3": 44
  },
  technicalDebt: {
    "automotive:OEM": 78, "automotive:T1": 70, "automotive:T2": 58, "automotive:T3": 45,
    "aerospace:OEM": 82, "aerospace:T1": 74, "aerospace:T2": 62, "aerospace:T3": 48,
    "electronics:OEM": 76, "electronics:T1": 68, "electronics:T2": 56, "electronics:T3": 42,
    "machinery:OEM": 74, "machinery:T1": 66, "machinery:T2": 54, "machinery:T3": 40
  },
  engineeringIPRisk: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 65, "automotive:T3": 50,
    "aerospace:OEM": 92, "aerospace:T1": 83, "aerospace:T2": 70, "aerospace:T3": 55,
    "electronics:OEM": 84, "electronics:T1": 76, "electronics:T2": 60, "electronics:T3": 45,
    "machinery:OEM": 80, "machinery:T1": 72, "machinery:T2": 58, "machinery:T3": 44
  },
  migrationComplexity: {
    "automotive:OEM": 70, "automotive:T1": 65, "automotive:T2": 55, "automotive:T3": 45,
    "aerospace:OEM": 75, "aerospace:T1": 68, "aerospace:T2": 58, "aerospace:T3": 48,
    "electronics:OEM": 68, "electronics:T1": 62, "electronics:T2": 52, "electronics:T3": 42,
    "machinery:OEM": 65, "machinery:T1": 60, "machinery:T2": 50, "machinery:T3": 40
  },
  cybersecurityExposure: {
    "automotive:OEM": 90, "automotive:T1": 82, "automotive:T2": 70, "automotive:T3": 55,
    "aerospace:OEM": 95, "aerospace:T1": 85, "aerospace:T2": 72, "aerospace:T3": 60,
    "electronics:OEM": 88, "electronics:T1": 78, "electronics:T2": 66, "electronics:T3": 50,
    "machinery:OEM": 85, "machinery:T1": 76, "machinery:T2": 64, "machinery:T3": 48
  },
  resilienceRequirement: {
    "automotive:OEM": 85, "automotive:T1": 78, "automotive:T2": 65, "automotive:T3": 50,
    "aerospace:OEM": 90, "aerospace:T1": 82, "aerospace:T2": 68, "aerospace:T3": 52,
    "electronics:OEM": 82, "electronics:T1": 74, "electronics:T2": 60, "electronics:T3": 45,
    "machinery:OEM": 80, "machinery:T1": 72, "machinery:T2": 58, "machinery:T3": 44
  },
  revenueResilience: {
    "automotive:OEM": 80, "automotive:T1": 75, "automotive:T2": 62, "automotive:T3": 48,
    "aerospace:OEM": 85, "aerospace:T1": 78, "aerospace:T2": 65, "aerospace:T3": 50,
    "electronics:OEM": 78, "electronics:T1": 70, "electronics:T2": 58, "electronics:T3": 44,
    "machinery:OEM": 76, "machinery:T1": 68, "machinery:T2": 55, "machinery:T3": 42
  },
  productComplexity: {
    "automotive:OEM": 95, "automotive:T1": 85, "automotive:T2": 70, "automotive:T3": 55,
    "aerospace:OEM": 98, "aerospace:T1": 88, "aerospace:T2": 72, "aerospace:T3": 58,
    "electronics:OEM": 90, "electronics:T1": 80, "electronics:T2": 65, "electronics:T3": 50,
    "machinery:OEM": 92, "machinery:T1": 82, "machinery:T2": 68, "machinery:T3": 52
  },
  changeFrequency: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 70, "automotive:T3": 60,
    "aerospace:OEM": 90, "aerospace:T1": 82, "aerospace:T2": 72, "aerospace:T3": 62,
    "electronics:OEM": 85, "electronics:T1": 76, "electronics:T2": 66, "electronics:T3": 56,
    "machinery:OEM": 83, "machinery:T1": 74, "machinery:T2": 64, "machinery:T3": 54
  },
  volumeVarietyMix: {
    "automotive:OEM": 80, "automotive:T1": 75, "automotive:T2": 65, "automotive:T3": 55,
    "aerospace:OEM": 85, "aerospace:T1": 78, "aerospace:T2": 68, "aerospace:T3": 58,
    "electronics:OEM": 78, "electronics:T1": 72, "electronics:T2": 62, "electronics:T3": 52,
    "machinery:OEM": 76, "machinery:T1": 70, "machinery:T2": 60, "machinery:T3": 50
  },
  cadIntensity: {
    "automotive:OEM": 90, "automotive:T1": 85, "automotive:T2": 75, "automotive:T3": 60,
    "aerospace:OEM": 95, "aerospace:T1": 88, "aerospace:T2": 78, "aerospace:T3": 62,
    "electronics:OEM": 85, "electronics:T1": 78, "electronics:T2": 68, "electronics:T3": 55,
    "machinery:OEM": 88, "machinery:T1": 80, "machinery:T2": 70, "machinery:T3": 56
  },
  lifecycleLength: {
    "automotive:OEM": 75, "automotive:T1": 68, "automotive:T2": 60, "automotive:T3": 52,
    "aerospace:OEM": 82, "aerospace:T1": 74, "aerospace:T2": 66, "aerospace:T3": 58,
    "electronics:OEM": 70, "electronics:T1": 65, "electronics:T2": 58, "electronics:T3": 50,
    "machinery:OEM": 72, "machinery:T1": 66, "machinery:T2": 60, "machinery:T3": 52
  },
  reusePotential: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 70, "automotive:T3": 60,
    "aerospace:OEM": 90, "aerospace:T1": 82, "aerospace:T2": 72, "aerospace:T3": 62,
    "electronics:OEM": 85, "electronics:T1": 76, "electronics:T2": 66, "electronics:T3": 56,
    "machinery:OEM": 83, "machinery:T1": 74, "machinery:T2": 64, "machinery:T3": 54
  },
  partCount: {
    "automotive:OEM": 92, "automotive:T1": 85, "automotive:T2": 78, "automotive:T3": 65,
    "aerospace:OEM": 95, "aerospace:T1": 88, "aerospace:T2": 80, "aerospace:T3": 70,
    "electronics:OEM": 90, "electronics:T1": 82, "electronics:T2": 75, "electronics:T3": 60,
    "machinery:OEM": 88, "machinery:T1": 80, "machinery:T2": 72, "machinery:T3": 58
  },
  productConfigurability: {
    "automotive:OEM": 86, "automotive:T1": 78, "automotive:T2": 68, "automotive:T3": 58,
    "aerospace:OEM": 90, "aerospace:T1": 82, "aerospace:T2": 70, "aerospace:T3": 60,
    "electronics:OEM": 85, "electronics:T1": 75, "electronics:T2": 65, "electronics:T3": 55,
    "machinery:OEM": 84, "machinery:T1": 74, "machinery:T2": 64, "machinery:T3": 52
  },
  portfolioBreadth: {
    "automotive:OEM": 80, "automotive:T1": 70, "automotive:T2": 60, "automotive:T3": 50,
    "aerospace:OEM": 85, "aerospace:T1": 74, "aerospace:T2": 65, "aerospace:T3": 55,
    "electronics:OEM": 78, "electronics:T1": 68, "electronics:T2": 58, "electronics:T3": 48,
    "machinery:OEM": 76, "machinery:T1": 66, "machinery:T2": 56, "machinery:T3": 46
  },
  programDuration: {
    "automotive:OEM": 82, "automotive:T1": 72, "automotive:T2": 62, "automotive:T3": 52,
    "aerospace:OEM": 88, "aerospace:T1": 78, "aerospace:T2": 68, "aerospace:T3": 58,
    "electronics:OEM": 80, "electronics:T1": 70, "electronics:T2": 60, "electronics:T3": 50,
    "machinery:OEM": 78, "machinery:T1": 68, "machinery:T2": 58, "machinery:T3": 48
  },
  crossDomainNeed: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 70, "automotive:T3": 60,
    "aerospace:OEM": 92, "aerospace:T1": 85, "aerospace:T2": 74, "aerospace:T3": 62,
    "electronics:OEM": 86, "electronics:T1": 78, "electronics:T2": 66, "electronics:T3": 55,
    "machinery:OEM": 84, "machinery:T1": 76, "machinery:T2": 64, "machinery:T3": 52
  },
  sensorizationLevel: {
    "automotive:OEM": 78, "automotive:T1": 70, "automotive:T2": 60, "automotive:T3": 50,
    "aerospace:OEM": 85, "aerospace:T1": 76, "aerospace:T2": 65, "aerospace:T3": 55,
    "electronics:OEM": 82, "electronics:T1": 74, "electronics:T2": 64, "electronics:T3": 52,
    "machinery:OEM": 76, "machinery:T1": 68, "machinery:T2": 58, "machinery:T3": 46
  },
  productAsPlatform: {
    "automotive:OEM": 85, "automotive:T1": 75, "automotive:T2": 62, "automotive:T3": 50,
    "aerospace:OEM": 90, "aerospace:T1": 78, "aerospace:T2": 65, "aerospace:T3": 52,
    "electronics:OEM": 80, "electronics:T1": 70, "electronics:T2": 58, "electronics:T3": 45,
    "machinery:OEM": 82, "machinery:T1": 72, "machinery:T2": 60, "machinery:T3": 48
  },
  legacyProcessGap: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 70, "automotive:T3": 60,
    "aerospace:OEM": 92, "aerospace:T1": 85, "aerospace:T2": 75, "aerospace:T3": 65,
    "electronics:OEM": 85, "electronics:T1": 78, "electronics:T2": 68, "electronics:T3": 58,
    "machinery:OEM": 83, "machinery:T1": 76, "machinery:T2": 66, "machinery:T3": 56
  },
  digitalMaturity: {
    "automotive:OEM": 90, "automotive:T1": 82, "automotive:T2": 72, "automotive:T3": 60,
    "aerospace:OEM": 95, "aerospace:T1": 86, "aerospace:T2": 76, "aerospace:T3": 64,
    "electronics:OEM": 88, "electronics:T1": 80, "electronics:T2": 70, "electronics:T3": 58,
    "machinery:OEM": 86, "machinery:T1": 78, "machinery:T2": 68, "machinery:T3": 56
  },
  infraReadiness: {
    "automotive:OEM": 85, "automotive:T1": 75, "automotive:T2": 60, "automotive:T3": 45,
    "aerospace:OEM": 90, "aerospace:T1": 80, "aerospace:T2": 65, "aerospace:T3": 50,
    "electronics:OEM": 82, "electronics:T1": 70, "electronics:T2": 58, "electronics:T3": 42,
    "machinery:OEM": 80, "machinery:T1": 68, "machinery:T2": 55, "machinery:T3": 40
  },
  toolFragmentation: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 68, "automotive:T3": 55,
    "aerospace:OEM": 92, "aerospace:T1": 84, "aerospace:T2": 70, "aerospace:T3": 58,
    "electronics:OEM": 85, "electronics:T1": 75, "electronics:T2": 64, "electronics:T3": 50,
    "machinery:OEM": 83, "machinery:T1": 72, "machinery:T2": 60, "machinery:T3": 48
  },
  manualExceptions: {
    "automotive:OEM": 82, "automotive:T1": 74, "automotive:T2": 65, "automotive:T3": 52,
    "aerospace:OEM": 86, "aerospace:T1": 78, "aerospace:T2": 68, "aerospace:T3": 54,
    "electronics:OEM": 80, "electronics:T1": 72, "electronics:T2": 62, "electronics:T3": 50,
    "machinery:OEM": 78, "machinery:T1": 70, "machinery:T2": 60, "machinery:T3": 48
  },
  systemAutomation: {
    "automotive:OEM": 90, "automotive:T1": 82, "automotive:T2": 70, "automotive:T3": 55,
    "aerospace:OEM": 94, "aerospace:T1": 86, "aerospace:T2": 74, "aerospace:T3": 58,
    "electronics:OEM": 88, "electronics:T1": 78, "electronics:T2": 66, "electronics:T3": 50,
    "machinery:OEM": 86, "machinery:T1": 76, "machinery:T2": 64, "machinery:T3": 48
  },
  exceptionVolume: {
    "automotive:OEM": 84, "automotive:T1": 76, "automotive:T2": 68, "automotive:T3": 54,
    "aerospace:OEM": 88, "aerospace:T1": 80, "aerospace:T2": 70, "aerospace:T3": 56,
    "electronics:OEM": 82, "electronics:T1": 74, "electronics:T2": 65, "electronics:T3": 50,
    "machinery:OEM": 80, "machinery:T1": 72, "machinery:T2": 62, "machinery:T3": 48
  },
  testInfrastructure: {
    "automotive:OEM": 78, "automotive:T1": 70, "automotive:T2": 60, "automotive:T3": 48,
    "aerospace:OEM": 85, "aerospace:T1": 76, "aerospace:T2": 65, "aerospace:T3": 50,
    "electronics:OEM": 75, "electronics:T1": 68, "electronics:T2": 58, "electronics:T3": 45,
    "machinery:OEM": 73, "machinery:T1": 66, "machinery:T2": 56, "machinery:T3": 44
  },
  legacyCustomizationDebt: {
    "automotive:OEM": 80, "automotive:T1": 72, "automotive:T2": 60, "automotive:T3": 45,
    "aerospace:OEM": 85, "aerospace:T1": 76, "aerospace:T2": 62, "aerospace:T3": 48,
    "electronics:OEM": 78, "electronics:T1": 70, "electronics:T2": 58, "electronics:T3": 42,
    "machinery:OEM": 76, "machinery:T1": 68, "machinery:T2": 56, "machinery:T3": 40
  },
  digitalThreadContinuity: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 70, "automotive:T3": 55,
    "aerospace:OEM": 92, "aerospace:T1": 84, "aerospace:T2": 72, "aerospace:T3": 58,
    "electronics:OEM": 86, "electronics:T1": 78, "electronics:T2": 66, "electronics:T3": 52,
    "machinery:OEM": 84, "machinery:T1": 76, "machinery:T2": 64, "machinery:T3": 50
  },
  skillDiversity: {
    "automotive:OEM": 78, "automotive:T1": 72, "automotive:T2": 62, "automotive:T3": 50,
    "aerospace:OEM": 82, "aerospace:T1": 75, "aerospace:T2": 64, "aerospace:T3": 52,
    "electronics:OEM": 76, "electronics:T1": 70, "electronics:T2": 60, "electronics:T3": 48,
    "machinery:OEM": 74, "machinery:T1": 68, "machinery:T2": 58, "machinery:T3": 46
  },
  userBuyin: {
    "automotive:OEM": 85, "automotive:T1": 78, "automotive:T2": 68, "automotive:T3": 55,
    "aerospace:OEM": 88, "aerospace:T1": 80, "aerospace:T2": 70, "aerospace:T3": 58,
    "electronics:OEM": 82, "electronics:T1": 74, "electronics:T2": 64, "electronics:T3": 50,
    "machinery:OEM": 80, "machinery:T1": 72, "machinery:T2": 62, "machinery:T3": 48
  },
  changeResistance: {
    "automotive:OEM": 82, "automotive:T1": 74, "automotive:T2": 64, "automotive:T3": 52,
    "aerospace:OEM": 85, "aerospace:T1": 76, "aerospace:T2": 66, "aerospace:T3": 54,
    "electronics:OEM": 78, "electronics:T1": 70, "electronics:T2": 60, "electronics:T3": 48,
    "machinery:OEM": 76, "machinery:T1": 68, "machinery:T2": 58, "machinery:T3": 46
  },
  plmTalentAvailability: {
    "automotive:OEM": 80, "automotive:T1": 72, "automotive:T2": 60, "automotive:T3": 45,
    "aerospace:OEM": 84, "aerospace:T1": 74, "aerospace:T2": 62, "aerospace:T3": 48,
    "electronics:OEM": 76, "electronics:T1": 68, "electronics:T2": 56, "electronics:T3": 42,
    "machinery:OEM": 74, "machinery:T1": 66, "machinery:T2": 54, "machinery:T3": 40
  },
  integrationDepth: {
    "automotive:OEM": 88, "automotive:T1": 78, "automotive:T2": 65, "automotive:T3": 50,
    "aerospace:OEM": 92, "aerospace:T1": 82, "aerospace:T2": 70, "aerospace:T3": 55,
    "electronics:OEM": 85, "electronics:T1": 75, "electronics:T2": 62, "electronics:T3": 48,
    "machinery:OEM": 82, "machinery:T1": 72, "machinery:T2": 60, "machinery:T3": 46
  },
  cloudOpsDiscipline: {
    "automotive:OEM": 75, "automotive:T1": 68, "automotive:T2": 55, "automotive:T3": 42,
    "aerospace:OEM": 80, "aerospace:T1": 72, "aerospace:T2": 60, "aerospace:T3": 45,
    "electronics:OEM": 72, "electronics:T1": 65, "electronics:T2": 52, "electronics:T3": 40,
    "machinery:OEM": 70, "machinery:T1": 62, "machinery:T2": 50, "machinery:T3": 38
  },
  eventDrivenIntegration: {
    "automotive:OEM": 80, "automotive:T1": 72, "automotive:T2": 58, "automotive:T3": 45,
    "aerospace:OEM": 85, "aerospace:T1": 76, "aerospace:T2": 62, "aerospace:T3": 48,
    "electronics:OEM": 78, "electronics:T1": 70, "electronics:T2": 56, "electronics:T3": 42,
    "machinery:OEM": 76, "machinery:T1": 68, "machinery:T2": 54, "machinery:T3": 40
  },
  digitalTwinConvergence: {
    "automotive:OEM": 90, "automotive:T1": 80, "automotive:T2": 65, "automotive:T3": 50,
    "aerospace:OEM": 94, "aerospace:T1": 84, "aerospace:T2": 68, "aerospace:T3": 52,
    "electronics:OEM": 86, "electronics:T1": 76, "electronics:T2": 60, "electronics:T3": 44,
    "machinery:OEM": 84, "machinery:T1": 74, "machinery:T2": 58, "machinery:T3": 42
  },
  dataLatencyTolerance: {
    "automotive:OEM": 70, "automotive:T1": 65, "automotive:T2": 55, "automotive:T3": 42,
    "aerospace:OEM": 75, "aerospace:T1": 70, "aerospace:T2": 58, "aerospace:T3": 44,
    "electronics:OEM": 68, "electronics:T1": 64, "electronics:T2": 52, "electronics:T3": 38,
    "machinery:OEM": 66, "machinery:T1": 62, "machinery:T2": 50, "machinery:T3": 36
  },
  ecosystemLicensingStrategy: {
    "automotive:OEM": 76, "automotive:T1": 68, "automotive:T2": 56, "automotive:T3": 45,
    "aerospace:OEM": 80, "aerospace:T1": 72, "aerospace:T2": 60, "aerospace:T3": 48,
    "electronics:OEM": 74, "electronics:T1": 66, "electronics:T2": 54, "electronics:T3": 42,
    "machinery:OEM": 72, "machinery:T1": 64, "machinery:T2": 52, "machinery:T3": 40
  },
  crossPlmInteroperability: {
    "automotive:OEM": 85, "automotive:T1": 76, "automotive:T2": 65, "automotive:T3": 52,
    "aerospace:OEM": 88, "aerospace:T1": 78, "aerospace:T2": 66, "aerospace:T3": 54,
    "electronics:OEM": 82, "electronics:T1": 74, "electronics:T2": 60, "electronics:T3": 48,
    "machinery:OEM": 80, "machinery:T1": 72, "machinery:T2": 58, "machinery:T3": 46
  },
  platformEcosystemParticipation: {
    "automotive:OEM": 82, "automotive:T1": 72, "automotive:T2": 60, "automotive:T3": 48,
    "aerospace:OEM": 85, "aerospace:T1": 75, "aerospace:T2": 62, "aerospace:T3": 50,
    "electronics:OEM": 80, "electronics:T1": 70, "electronics:T2": 58, "electronics:T3": 46,
    "machinery:OEM": 78, "machinery:T1": 68, "machinery:T2": 56, "machinery:T3": 44
  },
  speedSensitivity: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 68, "automotive:T3": 55,
    "aerospace:OEM": 85, "aerospace:T1": 76, "aerospace:T2": 64, "aerospace:T3": 50,
    "electronics:OEM": 90, "electronics:T1": 82, "electronics:T2": 70, "electronics:T3": 58,
    "machinery:OEM": 83, "machinery:T1": 75, "machinery:T2": 62, "machinery:T3": 50
  },
  competitivePressure: {
    "automotive:OEM": 92, "automotive:T1": 85, "automotive:T2": 72, "automotive:T3": 60,
    "aerospace:OEM": 88, "aerospace:T1": 80, "aerospace:T2": 68, "aerospace:T3": 55,
    "electronics:OEM": 95, "electronics:T1": 88, "electronics:T2": 76, "electronics:T3": 65,
    "machinery:OEM": 86, "machinery:T1": 78, "machinery:T2": 66, "machinery:T3": 54
  },
  innovationThroughput: {
    "automotive:OEM": 90, "automotive:T1": 82, "automotive:T2": 70, "automotive:T3": 58,
    "aerospace:OEM": 85, "aerospace:T1": 78, "aerospace:T2": 66, "aerospace:T3": 54,
    "electronics:OEM": 92, "electronics:T1": 84, "electronics:T2": 72, "electronics:T3": 60,
    "machinery:OEM": 84, "machinery:T1": 76, "machinery:T2": 64, "machinery:T3": 52
  },
  customerFeedbackLoop: {
    "automotive:OEM": 85, "automotive:T1": 78, "automotive:T2": 66, "automotive:T3": 54,
    "aerospace:OEM": 80, "aerospace:T1": 72, "aerospace:T2": 60, "aerospace:T3": 48,
    "electronics:OEM": 88, "electronics:T1": 80, "electronics:T2": 68, "electronics:T3": 56,
    "machinery:OEM": 82, "machinery:T1": 74, "machinery:T2": 62, "machinery:T3": 50
  },
  timeToValueAcceleration: {
    "automotive:OEM": 86, "automotive:T1": 78, "automotive:T2": 66, "automotive:T3": 52,
    "aerospace:OEM": 82, "aerospace:T1": 74, "aerospace:T2": 62, "aerospace:T3": 50,
    "electronics:OEM": 90, "electronics:T1": 82, "electronics:T2": 70, "electronics:T3": 58,
    "machinery:OEM": 84, "machinery:T1": 76, "machinery:T2": 64, "machinery:T3": 50
  },
  customerCoCreationCapability: {
    "automotive:OEM": 80, "automotive:T1": 72, "automotive:T2": 60, "automotive:T3": 48,
    "aerospace:OEM": 78, "aerospace:T1": 70, "aerospace:T2": 58, "aerospace:T3": 46,
    "electronics:OEM": 85, "electronics:T1": 76, "electronics:T2": 64, "electronics:T3": 52,
    "machinery:OEM": 80, "machinery:T1": 72, "machinery:T2": 60, "machinery:T3": 48
  },
  regulatoryBurden: {
    "automotive:OEM": 94, "automotive:T1": 85, "automotive:T2": 72, "automotive:T3": 60,
    "aerospace:OEM": 98, "aerospace:T1": 90, "aerospace:T2": 78, "aerospace:T3": 65,
    "electronics:OEM": 90, "electronics:T1": 82, "electronics:T2": 70, "electronics:T3": 58,
    "machinery:OEM": 88, "machinery:T1": 80, "machinery:T2": 68, "machinery:T3": 55
  },
  recallRisk: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 70, "automotive:T3": 60,
    "aerospace:OEM": 92, "aerospace:T1": 84, "aerospace:T2": 74, "aerospace:T3": 62,
    "electronics:OEM": 85, "electronics:T1": 78, "electronics:T2": 68, "electronics:T3": 58,
    "machinery:OEM": 83, "machinery:T1": 76, "machinery:T2": 66, "machinery:T3": 55
  },
  traceabilityNeed: {
    "automotive:OEM": 90, "automotive:T1": 82, "automotive:T2": 72, "automotive:T3": 60,
    "aerospace:OEM": 96, "aerospace:T1": 88, "aerospace:T2": 76, "aerospace:T3": 64,
    "electronics:OEM": 88, "electronics:T1": 80, "electronics:T2": 70, "electronics:T3": 58,
    "machinery:OEM": 86, "machinery:T1": 78, "machinery:T2": 68, "machinery:T3": 55
  },
  compliancePenalty: {
    "automotive:OEM": 93, "automotive:T1": 85, "automotive:T2": 72, "automotive:T3": 60,
    "aerospace:OEM": 97, "aerospace:T1": 90, "aerospace:T2": 78, "aerospace:T3": 65,
    "electronics:OEM": 89, "electronics:T1": 82, "electronics:T2": 70, "electronics:T3": 58,
    "machinery:OEM": 87, "machinery:T1": 80, "machinery:T2": 68, "machinery:T3": 55
  },
  namingDiscipline: {
    "automotive:OEM": 78, "automotive:T1": 70, "automotive:T2": 60, "automotive:T3": 48,
    "aerospace:OEM": 82, "aerospace:T1": 74, "aerospace:T2": 62, "aerospace:T3": 50,
    "electronics:OEM": 76, "electronics:T1": 68, "electronics:T2": 58, "electronics:T3": 46,
    "machinery:OEM": 74, "machinery:T1": 66, "machinery:T2": 56, "machinery:T3": 44
  },
  dataGovernanceQuality: {
    "automotive:OEM": 84, "automotive:T1": 76, "automotive:T2": 65, "automotive:T3": 52,
    "aerospace:OEM": 88, "aerospace:T1": 80, "aerospace:T2": 70, "aerospace:T3": 58,
    "electronics:OEM": 82, "electronics:T1": 74, "electronics:T2": 64, "electronics:T3": 50,
    "machinery:OEM": 80, "machinery:T1": 72, "machinery:T2": 60, "machinery:T3": 48
  },
  endToEndTraceability: {
    "automotive:OEM": 90, "automotive:T1": 82, "automotive:T2": 72, "automotive:T3": 60,
    "aerospace:OEM": 95, "aerospace:T1": 86, "aerospace:T2": 76, "aerospace:T3": 62,
    "electronics:OEM": 88, "electronics:T1": 80, "electronics:T2": 70, "electronics:T3": 58,
    "machinery:OEM": 86, "machinery:T1": 78, "machinery:T2": 68, "machinery:T3": 55
  },
  dataProvenance: {
    "automotive:OEM": 84, "automotive:T1": 76, "automotive:T2": 66, "automotive:T3": 54,
    "aerospace:OEM": 88, "aerospace:T1": 80, "aerospace:T2": 70, "aerospace:T3": 58,
    "electronics:OEM": 82, "electronics:T1": 74, "electronics:T2": 64, "electronics:T3": 52,
    "machinery:OEM": 80, "machinery:T1": 72, "machinery:T2": 62, "machinery:T3": 50
  },
  regulatoryAuditReadiness: {
    "automotive:OEM": 90, "automotive:T1": 82, "automotive:T2": 70, "automotive:T3": 58,
    "aerospace:OEM": 95, "aerospace:T1": 86, "aerospace:T2": 74, "aerospace:T3": 60,
    "electronics:OEM": 88, "electronics:T1": 78, "electronics:T2": 68, "electronics:T3": 55,
    "machinery:OEM": 86, "machinery:T1": 76, "machinery:T2": 64, "machinery:T3": 52
  },
  errorCost: {
    "automotive:OEM": 92, "automotive:T1": 84, "automotive:T2": 74, "automotive:T3": 62,
    "aerospace:OEM": 96, "aerospace:T1": 88, "aerospace:T2": 78, "aerospace:T3": 64,
    "electronics:OEM": 90, "electronics:T1": 82, "electronics:T2": 72, "electronics:T3": 60,
    "machinery:OEM": 88, "machinery:T1": 80, "machinery:T2": 70, "machinery:T3": 58
  },
  delayPenalty: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 70, "automotive:T3": 58,
    "aerospace:OEM": 92, "aerospace:T1": 84, "aerospace:T2": 74, "aerospace:T3": 60,
    "electronics:OEM": 86, "electronics:T1": 78, "electronics:T2": 68, "electronics:T3": 56,
    "machinery:OEM": 84, "machinery:T1": 76, "machinery:T2": 66, "machinery:T3": 54
  },
  engineeringCost: {
    "automotive:OEM": 86, "automotive:T1": 78, "automotive:T2": 66, "automotive:T3": 54,
    "aerospace:OEM": 90, "aerospace:T1": 82, "aerospace:T2": 70, "aerospace:T3": 58,
    "electronics:OEM": 84, "electronics:T1": 76, "electronics:T2": 64, "electronics:T3": 52,
    "machinery:OEM": 82, "machinery:T1": 74, "machinery:T2": 62, "machinery:T3": 50
  },
  reuseLibrary: {
    "automotive:OEM": 80, "automotive:T1": 72, "automotive:T2": 62, "automotive:T3": 50,
    "aerospace:OEM": 84, "aerospace:T1": 76, "aerospace:T2": 66, "aerospace:T3": 54,
    "electronics:OEM": 78, "electronics:T1": 70, "electronics:T2": 60, "electronics:T3": 48,
    "machinery:OEM": 76, "machinery:T1": 68, "machinery:T2": 58, "machinery:T3": 46
  },
  ipRisk: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 70, "automotive:T3": 58,
    "aerospace:OEM": 92, "aerospace:T1": 84, "aerospace:T2": 74, "aerospace:T3": 60,
    "electronics:OEM": 86, "electronics:T1": 78, "electronics:T2": 68, "electronics:T3": 56,
    "machinery:OEM": 84, "machinery:T1": 76, "machinery:T2": 66, "machinery:T3": 54
  },
  aftermarketFocus: {
    "automotive:OEM": 82, "automotive:T1": 74, "automotive:T2": 64, "automotive:T3": 52,
    "aerospace:OEM": 86, "aerospace:T1": 78, "aerospace:T2": 68, "aerospace:T3": 56,
    "electronics:OEM": 80, "electronics:T1": 72, "electronics:T2": 62, "electronics:T3": 50,
    "machinery:OEM": 78, "machinery:T1": 70, "machinery:T2": 60, "machinery:T3": 48
  },
  aiReadiness: {
    "automotive:OEM": 90, "automotive:T1": 80, "automotive:T2": 68, "automotive:T3": 55,
    "aerospace:OEM": 92, "aerospace:T1": 82, "aerospace:T2": 70, "aerospace:T3": 58,
    "electronics:OEM": 94, "electronics:T1": 84, "electronics:T2": 72, "electronics:T3": 60,
    "machinery:OEM": 88, "machinery:T1": 78, "machinery:T2": 66, "machinery:T3": 54
  },
  analyticsCapability: {
    "automotive:OEM": 86, "automotive:T1": 78, "automotive:T2": 66, "automotive:T3": 54,
    "aerospace:OEM": 90, "aerospace:T1": 82, "aerospace:T2": 70, "aerospace:T3": 58,
    "electronics:OEM": 92, "electronics:T1": 84, "electronics:T2": 72, "electronics:T3": 60,
    "machinery:OEM": 85, "machinery:T1": 76, "machinery:T2": 64, "machinery:T3": 52
  },
  aiCoDesignAdoption: {
    "automotive:OEM": 84, "automotive:T1": 76, "automotive:T2": 64, "automotive:T3": 50,
    "aerospace:OEM": 88, "aerospace:T1": 78, "aerospace:T2": 66, "aerospace:T3": 52,
    "electronics:OEM": 90, "electronics:T1": 80, "electronics:T2": 68, "electronics:T3": 54,
    "machinery:OEM": 82, "machinery:T1": 74, "machinery:T2": 62, "machinery:T3": 48
  },
  intelligentWorkflowOrchestration: {
    "automotive:OEM": 88, "automotive:T1": 80, "automotive:T2": 68, "automotive:T3": 54,
    "aerospace:OEM": 92, "aerospace:T1": 84, "aerospace:T2": 72, "aerospace:T3": 58,
    "electronics:OEM": 94, "electronics:T1": 86, "electronics:T2": 74, "electronics:T3": 60,
    "machinery:OEM": 86, "machinery:T1": 78, "machinery:T2": 66, "machinery:T3": 52
  }
};

